import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getSettings(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/get/settings",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function addSettings(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/add/setting",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function updateSettings(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/add/setting",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
export const DefaultSettingServices = {
    getSettings,
    addSettings,
    updateSettings
}